import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import styles from "./how-it-works.module.css";
import { IconCard } from "../icon-card";
import { StoreCtaButton } from "../cta-button";
export function HowItWorks({ title , howCinchWorksList , slug  }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.cardList,
                children: howCinchWorksList.map((listItem)=>/*#__PURE__*/ _jsx(IconCard, {
                        icon: listItem.icon,
                        title: listItem.title,
                        body: listItem.body
                    }, listItem.title))
            }),
            /*#__PURE__*/ _jsx(StoreCtaButton, {
                slug: slug,
                trackEventTitle: "how it works"
            })
        ]
    });
}
